module.exports = __webpack_public_path__ + "img/Huygenstijdmachine_Gemeente-Leidschendam-Voorburg.f844289b.svg";